import PostEditor from "../../templates/PostEditor";

const UpdatePost = () => {
  return <PostEditor isEdit={true} />;
};

export default UpdatePost;
